import { Core } from "@planzone/core";
import { Selector } from "@planzone/state";
import { EventDispatcher } from "@planzone/events";
import { createContext } from "react";

const CoreContext = createContext<{
  core: Core;
  selector: Selector;
  eventDispatcher: EventDispatcher;
}>({
  core: {},
  eventDispatcher: {},
  selector: {},
} as {
  core: Core;
  selector: Selector;
  eventDispatcher: EventDispatcher;
});

export { CoreContext };
